<h2 mat-dialog-title class="text-lg font-bold mb-1">
  {{ isEditMode ? "Editar Registro" : "Nuevo Registro" }}
</h2>
<mat-dialog-content class="modal-content">
  <form #createForm="ngForm" class="grid grid-cols-2 gap-4">
    <!--<mat-form-field appearance="fill" class="col-span-1">
      <mat-label>Codigo</mat-label>
      @if(isEditMode!){
      <input
        matInput
        [(ngModel)]="currentCreateBusinessPartnerAddress.isSync"
        name="code"
        disabled
      />
      }@else{
        <input
        matInput
        [(ngModel)]="currentCreateBusinessPartnerAddress.isSync"
        name="code"
        required
      />
      }
    </mat-form-field>-->

    <mat-form-field appearance="fill" class="col-span-1">
      <mat-label>Nombre</mat-label>
      <input matInput [(ngModel)]="currentCreateBusinessPartnerAddress.name" name="name" required />
    </mat-form-field>

    <!-- <mat-form-field appearance="fill" class="col-span-1">
      <mat-label>Latitud</mat-label>
      <input
        type="number"
        matInput
        [(ngModel)]="currentCreateBusinessPartnerAddress.geolocationPoint[0]"
        name="geolocationLatitude"
      />
    </mat-form-field>
    <mat-form-field appearance="fill" class="col-span-1">
      <mat-label>Longitud</mat-label>
      <input
        type="number"
        matInput
        [(ngModel)]="currentCreateBusinessPartnerAddress.geolocationPoint[1]"
        name="geolocationLongitude"
      />
    </mat-form-field> -->

    <mat-form-field appearance="fill" class="col-span-1">
      <mat-label>Referencia</mat-label>
      <input matInput [(ngModel)]="currentCreateBusinessPartnerAddress.reference" name="lastName" />
    </mat-form-field>

    <mat-form-field appearance="fill" class="col-span-2">
      <mat-label>Dirección</mat-label>
      <textarea matInput [(ngModel)]="currentCreateBusinessPartnerAddress.address" name="address" required rows="3"
        cdkTextareaAutosize #autosize="cdkTextareaAutosize"></textarea>
    </mat-form-field>

    <mat-form-field appearance="fill" class="col-span-1">
      <mat-label>Latitud</mat-label>
      <input type="text" matInput [(ngModel)]="currentCreateBusinessPartnerAddress.geolocationPoint[0]"
        (ngModelChange)="validateDecimal($event, 'latitud')" name="geolocationLatitude" inputmode="decimal"
        placeholder="Ej: 8.22223233" #latInput="ngModel" />
      <mat-error *ngIf="latitudError">Formato inválido. Use un punto (.) como separador decimal.</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" class="col-span-1">
      <mat-label>Longitud</mat-label>
      <input type="text" matInput [(ngModel)]="currentCreateBusinessPartnerAddress.geolocationPoint[1]"
        (ngModelChange)="validateDecimal($event, 'longitud')" name="geolocationLongitude" inputmode="decimal"
        placeholder="Ej: -1233.20323023" #lngInput="ngModel" />
      <mat-error *ngIf="longitudError">Formato inválido. Use un punto (.) como separador decimal.</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" class="col-span-1">
      <mat-label>Código Postal</mat-label>
      <input matInput [(ngModel)]="currentCreateBusinessPartnerAddress.postalCode" name="postalCode" />
    </mat-form-field>

    <div class="col-span-1">
      <mat-label>País</mat-label>
      <ng-select [(ngModel)]="currentCreateBusinessPartnerAddress.locationOneId" [items]="locationOneList"
        bindLabel="name" bindValue="_id" [searchable]="true" placeholder="Seleccione un país" name="locationOneId"
        [appendTo]="'body'" (change)="changeLocationOne($event)">
      </ng-select>
    </div>
    <div class="col-span-1">
      <label>Departamento</label>
      <ng-select [(ngModel)]="currentCreateBusinessPartnerAddress.locationTwoId" [items]="locationTwoList"
        bindLabel="name" bindValue="_id" [searchable]="true" placeholder="Seleccione un departamento"
        name="locationTwoId" [appendTo]="'body'" (change)="changeLocationTwo($event)">
      </ng-select>
    </div>
    <div class="col-span-1">
      <label>Ciudad</label>
      <ng-select [(ngModel)]="currentCreateBusinessPartnerAddress.locationThreeId" [items]="locationThreeList"
        bindLabel="name" bindValue="_id" [searchable]="true" placeholder="Seleccione una ciudad" name="locationThreeId"
        (change)="changeLocationFour($event)"
        [appendTo]="'body'">
      </ng-select>
    </div>

   <div class="col-span-1">
      <label>Colonia/Distrito</label>
      <ng-select
        [(ngModel)]="currentCreateBusinessPartnerAddress.locationFourId"
        [items]="locationFourList"
        bindLabel="name"
        bindValue="_id"
        [searchable]="true"
        placeholder="Seleccione una colonia"
        name="locationFourId"
        [appendTo]="'body'"
      >
      </ng-select>
    </div>

    <mat-form-field appearance="fill" class="col-span-1">
      <mat-label>Nombre del Contacto</mat-label>
      <input matInput [(ngModel)]="currentCreateBusinessPartnerAddress.contactName" name="contactName" />
    </mat-form-field>

    <mat-form-field appearance="fill" class="col-span-1">
      <mat-label for="group-select">Territorios</mat-label>
      <mat-select [formControl]="routeMultiCtrl" placeholder="Seleccione territorio" [multiple]="true"
        [compareWith]="compareRoutes">
        <mat-option>
          <ngx-mat-select-search [showToggleAllCheckbox]="true" [toggleAllCheckboxIndeterminate]="isIndeterminate"
            [toggleAllCheckboxChecked]="isChecked" (toggleAll)="toggleSelectAll($event)"
            [formControl]="routeMultiFilterCtrl" [noEntriesFoundLabel]="'No se encontraron resultados'"
            [placeholderLabel]="'Buscar territorio...'"></ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let route of sortedRoutes$ | async" [value]="route">
          <div class="route-option-container w-full">
            <span>
              <b *ngIf="getCode(route) as code">{{ code }} -</b>
              {{ route.name }}
            </span>

            <div>
              <mat-slide-toggle (click)="$event.stopPropagation()" color="primary" (change)="
                  route.isPrincipal
                    ? markAsPrincipal(route)
                    : markAsPrincipal(null)
                " [disabled]="isPrincipalDisabled(route) | async" [(ngModel)]="route.isPrincipal"
                [ngModelOptions]="{ standalone: true }">
                <span>Principal</span>
              </mat-slide-toggle>
            </div>
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="col-span-1">
      <mat-label>Tipo de Dirección</mat-label>
      <ng-select [(ngModel)]="currentCreateBusinessPartnerAddress.addresstypeId" [items]="addressList" bindLabel="name"
        bindValue="_id" [searchable]="true" placeholder="Seleccione un tipo" name="addresstypeId" [appendTo]="'body'"
        required>
        <!-- Plantilla para las opciones en el dropdown -->
        <ng-template ng-option-tmp let-item="item">
          <span>
            {{ item.name }}
            <span *ngIf="item.isDelivery === true" class="ml-2 px-2 py-0.5 rounded bg-blue-600 text-white text-xs">
              ENTREGA
            </span>
          </span>
        </ng-template>

        <ng-template ng-label-tmp let-item="item">
          <span>
            {{ item.name }}
            <span *ngIf="item.isDelivery === true" class="ml-2 px-2 py-0.5 rounded bg-blue-600 text-white text-xs">
              ENTREGA
            </span>
          </span>
        </ng-template>
      </ng-select>
    </div>

    <!-- <div class="col-span-1">
      <label>B</label>
      <ng-select
        [(ngModel)]="currentCreateBusinessPartnerAddress.locationFourId"
        [items]="locationFourList"
        bindLabel="name"
        bindValue="_id"
        [searchable]="true"
        placeholder="Seleccione un B"
        name="locationFourId"
        [appendTo]="'body'"
      >
      </ng-select>
    </div>
    <div class="col-span-1">
      <label>C</label>
      <ng-select
        [(ngModel)]="currentCreateBusinessPartnerAddress.locationFiveId"
        [items]="locationFiveList"
        bindLabel="name"
        bindValue="_id"
        [searchable]="true"
        placeholder="Seleccione un C"
        name="locationFiveId"
        [appendTo]="'body'"
      >
      </ng-select>
    </div>
    <div class="col-span-1">
      <label>D</label>
      <ng-select
        [(ngModel)]="currentCreateBusinessPartnerAddress.locationSixId"
        [items]="locationSixList"
        bindLabel="name"
        bindValue="_id"
        [searchable]="true"
        placeholder="Seleccione un D"
        name="locationSixId"
        [appendTo]="'body'"
      >
      </ng-select>
    </div> -->

    <div class="col-span-1 flex items-center">
      <span class="slide">¿Dirección Principal?</span>
      <mat-slide-toggle [(ngModel)]="currentCreateBusinessPartnerAddress.isPrincipal" name="isPrincipal"
        color="primary">
      </mat-slide-toggle>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="!createForm.valid" class="justify-end">
    {{ isEditMode ? "Actualizar" : "Guardar" }}
  </button>
</mat-dialog-actions>